import { faqAccordion } from '../utils/faq';
import { screenshotsAccordion } from '../utils/screenshots';

document.addEventListener('DOMContentLoaded', function (e) {
  faqAccordion();
  screenshotsAccordion();
});

import 'jquery';
import '../utils/slick.js';
var ev1 = document.createElement('script');
ev1.src = '//fast.wistia.com/assets/external/E-v1.js';
ev1.async = true;
ev1.charset = 'ISO-8859-1';
document.head.appendChild(ev1);

$(function () {
  const bestHeroLogos = $('.bestsl-hero__logos');
  bestHeroLogos.slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    dots: false,
    infinite: true,
    slidesToShow: 7,
    speed: 6000,
    swipe: false,
    pauseOnHover: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 6
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3
        }
      }
    ],
    init: function (event, slick) {
      blockHeroLogos.find('.slick-slide').css('opacity', 0);
      blockHeroLogos.find('.slick-slide').animate({ opacity: 1 }, 500);
    }
  });

  function updateSlideCounter(section, slider) {
    if (!slider || !slider.slick('getSlick')) {
      console.error('Slider is not properly initialized.');
      return;
    }

    const slickInstance = slider.slick('getSlick');
    const currentSlide = ((slider.slick('slickCurrentSlide') || 0) + 1)
      .toString()
      .padStart(2, '0');
    const totalSlides = (slickInstance.slideCount || 0)
      .toString()
      .padStart(2, '0');

    section.find('.current-slide').text(currentSlide);
    section.find('.total-slides').text(totalSlides);
  }

  function equalizeHeights(cards) {
    let maxHeight = 0;
    cards.css('height', 'auto');
    cards.each(function () {
      const cardHeight = $(this).height();
      if (cardHeight > maxHeight) {
        maxHeight = cardHeight;
      }
    });
    cards.height(maxHeight);
  }

  const reviewsslSection = $('.reviewssl');
  const reviewsslList = $('.reviewssl__list');

  reviewsslList.slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    dots: false,
    prevArrow: $('.reviewssl .arrow-prev'),
    nextArrow: $('.reviewssl .arrow-next'),
    responsive: [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  const reviewsslCards = reviewsslList.find('.reviewssl__item-card');
  const reviewsslItemHead = reviewsslList.find('.reviewssl__item-head');
  equalizeHeights(reviewsslItemHead);
  equalizeHeights(reviewsslCards);

  reviewsslList.on('afterChange', function () {
    updateSlideCounter(reviewsslSection, reviewsslList);
  });

  $(window).on('resize orientationchange', function () {
    setTimeout(function () {
      updateSlideCounter(reviewsslSection, reviewsslList);
      equalizeHeights(reviewsslItemHead);
      equalizeHeights(reviewsslCards);
      updateSlideCounter_2(reviecarouselSection, js_carousel_item);
    }, 100);
  });

  updateSlideCounter(reviewsslSection, reviewsslList);

  const reviecarouselSection = $('.caroucel-video-block');
  const js_carousel_item = $('.js-carousel-item');
  js_carousel_item.slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    dots: false,
    prevArrow: $('.caroucel-video-block .control-items .arrow_item-prev'),
    nextArrow: $('.caroucel-video-block .control-items .arrow_item-next'),
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          centerMode: true,
          centerPadding: '110px'
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '205px'
        }
      },
      {
        breakpoint: 620,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '110px'
        }
      },
      {
        breakpoint: 431,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '30px'
        }
      }
    ]
  });

  //  const reviewsslCards = reviewsslList.find('.reviewssl__item-card');
  //  const reviewsslItemHead = reviewsslList.find('.reviewssl__item-head');
  //  equalizeHeights(reviewsslItemHead);
  //  equalizeHeights(reviewsslCards);

  js_carousel_item.on('afterChange', function () {
    updateSlideCounter_2(reviecarouselSection, js_carousel_item);
  });
  updateSlideCounter_2(reviecarouselSection, js_carousel_item);

  function updateSlideCounter_2(section, slider) {
    // Check if the slider is initialized properly
    if (!slider || !slider.slick || !slider.slick('getSlick')) {
      console.error('Slider is not properly initialized.');
      return;
    }

    const slickInstance = slider.slick('getSlick');
    const currentSlide = ((slider.slick('slickCurrentSlide') || 0) + 1)
      .toString()
      .padStart(2, '0');
    const totalSlides = (slickInstance.slideCount || 0)
      .toString()
      .padStart(2, '0');

    // Update the DOM with the current and total slides
    section.find('.current-slide').text(currentSlide);
    section.find('.total-slides').text(totalSlides);
  }
});
